import FilePreview from './FilePreview';

export default FilePreview;
